import { useState } from 'react';
import PageGridAlt from '../Components/PageGridAlt';
import useFetch from '../Hooks/useFetch';
import {GrCaretNext, GrCaretPrevious} from 'react-icons/gr';

const InTheater = ()=>{
    const key  = process.env.REACT_APP_API_KEY;
    const [page,setPage] = useState(1);
    const {results:movies} = useFetch(`https://api.themoviedb.org/3/movie/now_playing?api_key=${key}&language=en-US&sort_by=popularity.desc&page=${page}`);

    const handlePage = (e)=>{
        if(e.target.innerText==='Next'){
            setPage(state=>state+1);
        }
        else{
            if(page===1){
                setPage(1);
            }
            setPage(state=>state-1);
        }
    }
   
    return <div className="dark:bg-secondary-dark min-h-screen pt-12 pb-2 ">
        {
            (movies)?
            <PageGridAlt data={movies}/>
            :
            null
        }
        <section className='flex flex-row justify-center lg:text-lg md:text-md text-sm text-button-text mt-4'>
            <button className='bg-button dark:bg-button-dark mr-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}><GrCaretPrevious/>Prev</button>
            <button className='bg-button dark:bg-button-dark ml-2 px-4 py-1 flex flex-row items-center' onClick={handlePage}>Next<GrCaretNext/></button>
        </section>
    </div>
}

export default InTheater;